module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('index')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f551661!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/download/Index.vue
// module id = 1323
// module chunks = 1